var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gameItem",on:{"click":function($event){return _vm.toGame()}}},[_c('div',{staticClass:"background"},[_vm._t("background")],2),_c('p',[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }